import { useSelector } from 'react-redux'

import { institutionItemSelectors } from '@ucheba/store/institutions/item'
import {
  IAddresses,
  IPhone,
  ISocialAccounts,
} from '@ucheba/store/institutions/item/types'

import { IPin } from '../../../../../../components/Map/types'

type TUseContacts = () => {
  email: string | null
  webSite: string | null
  phoneNumbers: IPhone[]
  pins: IPin[]
  socialAccounts: ISocialAccounts[]
  addresses: IAddresses[]
  webSiteName: string
}

export const useContacts: TUseContacts = () => {
  const {
    addresses = [],
    email,
    webSite,
    socialAccounts = [],
    paidPackage,
  } = useSelector(institutionItemSelectors.currentInstitution)

  let webSiteName = ''
  try {
    webSiteName = new URL(webSite).hostname
  } catch (err) {
    webSiteName = webSite
  }

  const pins = addresses.map(({ point, name, location }) => ({
    ...point,
    name,
    address: `г. ${location.name}`,
    description: '',
    color: '#1d8afe',
  }))

  const phoneNumbers = addresses?.flatMap(({ phones }) => phones)

  return {
    email: paidPackage ? email : null,
    webSite: paidPackage ? webSite : null,
    socialAccounts: paidPackage ? socialAccounts : [],
    pins,
    phoneNumbers,
    addresses,
    webSiteName,
  }
}
